import { tByRoute } from '../../../../shared/components/l10n/l10n';

const isRelocationBook = book => book.type === 1;

const hiddenRoutes = ['/sales/invoicing/invoices/:id', '/sales/invoicing/quotations/:id', '/sales/invoicing/orders/:id'];

export default function generateRouteShortcuts(data, routes) {
    const cache: any[] = [];
    const flattenedRoutes = Object.keys(routes);
    const baseRoutes = flattenedRoutes.filter(route => route.lastIndexOf('/') === 0);

    baseRoutes.forEach(baseRoute => {
        cache.push({
            title: tByRoute(baseRoute),
            action: navigate => navigate(baseRoute),
            type: 'tab',
        });
        const pageRoutes = flattenedRoutes.filter(
            route => route.startsWith(baseRoute) && route.lastIndexOf('/') === baseRoute.length
        );

        if (pageRoutes.length > 0) {
            pageRoutes.forEach(pageRoute => {
                const menuRoutes = flattenedRoutes.filter(route => route.startsWith(pageRoute));

                menuRoutes.forEach(menuRoute => {
                    if (hiddenRoutes.includes(menuRoute)) {
                        return;
                    }

                    if (menuRoute === '/accounting/journals/:id') {
                        if (data && data.journals && data.journals.length) {
                            data.journals.forEach(journal =>
                                cache.push({
                                    title: journal.name,
                                    section: baseRoute,
                                    group: pageRoute,
                                    action: navigate => navigate(`/accounting/journals/${journal.id}`),
                                    type: 'link',
                                })
                            );
                        }
                    } else if (menuRoute === '/inventory/books/:id') {
                        if (data && data.inventoryBooks && data.inventoryBooks.length) {
                            data.inventoryBooks
                                .filter(book => !isRelocationBook(book))
                                .forEach(inventoryBook =>
                                    cache.push({
                                        title: inventoryBook.name,
                                        section: baseRoute,
                                        group: pageRoute,
                                        action: navigate => navigate(`/inventory/books/${inventoryBook.id}`),
                                        type: 'link',
                                    })
                                );
                        }
                    } else if (menuRoute === '/inventory/books/relocation/:id') {
                        if (data && data.inventoryBooks && data.inventoryBooks.length) {
                            data.inventoryBooks.filter(isRelocationBook).forEach(inventoryBook =>
                                cache.push({
                                    title: inventoryBook.name,
                                    section: baseRoute,
                                    group: pageRoute,
                                    action: navigate => navigate(`/inventory/books/relocation/${inventoryBook.id}`),
                                    type: 'link',
                                })
                            );
                        }
                    } else if (menuRoute === '/projects/usage/:id') {
                        if (data && data.projectBooks && data.projectBooks.length) {
                            data.projectBooks.forEach(projectBook =>
                                cache.push({
                                    title: projectBook.name,
                                    section: baseRoute,
                                    group: pageRoute,
                                    action: navigate => navigate(`/projects/usage/${projectBook.id}`),
                                    type: 'link',
                                })
                            );
                        }
                    } else {
                        cache.push({
                            title: tByRoute(menuRoute),
                            section: baseRoute,
                            group: pageRoute,
                            action: navigate => navigate(menuRoute),
                            type: 'link',
                        });
                    }
                });
            });
        }
    });

    return cache;
}
